import { Box, ButtonGroup, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import AcceptIconButton from "../../../../../Components/AcceptButton/AcceptIconButton";
import RejectIconButton from "../../../../../Components/RejectButton/RejectIconButton";
import { useAppDataProvider } from "../../../../../dataprovider";
import { RemarkTypes } from "../../../../../Enums/RemarkTypes";

export const Actions = props => {
  const [remark, setRemark] = useState("");
  const [remarkValidation, setRemarkValidation] = React.useState(false);
  var dataProvider = useAppDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const handleApprove = record => {
    dataProvider
      .post("eightwings/ttverified", { id: record.id })
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record verified`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };
  const handleRejectWithRemark = record => {
    const remarkModel = {
      requestId: record.requestId,
      statusCode: 0,
      remark: remark,
      remarkTypeCode: RemarkTypes[RemarkTypes.EightWingsTTNotVerifiedRemark],
      remarkType: RemarkTypes.EightWingsTTNotVerifiedRemark,
      isCustomer: false,
    };
    dataProvider
      .createPbhRequestRemarks(remarkModel)
      .then(response => {
        handleReject(record);
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleReject = record => {
    dataProvider
      .post("eightwings/ttnotverified", { id: record.id })
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record rejected`, "success", false, true);
        handleRejectDialogClose();
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };
  const validation = () => {
    if (!remark) {
      setRemarkValidation(true);
      return false;
    } else {
      setRemarkValidation(false);
      return true;
    }
  };
  const handleRejectDialogClose = () => {
    setRemark("");
    setRemarkValidation(false);
  };
  const handleChangeRemark = e => setRemark(e.target.value);
  return (
    <Box style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "8px" }}>
      <ButtonGroup variant="text" size="small">
        <AcceptIconButton {...props} resource={"eightwings/ttverified"} onClick={handleApprove} />
        <RejectIconButton
          {...props}
          validation={validation}
          resource={"eightwings/ttnotverified"}
          onClick={handleRejectWithRemark}
          title={`Are you sure you want to reject?`}
          onClose={handleRejectDialogClose}
          content={
            <TextField
              label="Remark"
              error={remarkValidation}
              required
              value={remark}
              multiline
              fullWidth
              maxRows={4}
              variant="outlined"
              onChange={handleChangeRemark}
            />
          }
        />
      </ButtonGroup>
    </Box>
  );
};
export default Actions;
